import { useSelector, shallowEqual } from 'react-redux';

import { selectElectricVehicle } from 'state/electric-vehicle/electric-vehicle-slice';

import { usePartner } from 'components/app/routes/usePartner';
import { useIsEVQuote } from './useIsEVQuote';
import { useMeterType } from './useMeterType';
import { useIsLoginEnabledJourney } from 'hooks/useIsLoginEnabledJourney';

import { PARTNERS } from 'config/app-config';

export const useEvTariffInformation = () => {
  const { isEVBeforeQuote } = useIsEVQuote();
  const { isDSJourney, activePartner } = usePartner();
  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];
  const { isEvException } = useMeterType();
  const electricVehicle = useSelector(selectElectricVehicle, shallowEqual);
  const isAgentSalesJourney = useIsLoginEnabledJourney({
    exclude: [PARTNERS.NONDOMESTIC_TRANSFER]
  });

  const isAllowedJourney =
    isAgentSalesJourney || isDSJourney || isMoveInJourney;

  return {
    showEvTariffInformation:
      !isEvException && electricVehicle && isAllowedJourney && !isEVBeforeQuote
  };
};
